import { RG68_23 } from "./RG68_23"
import { RG68_29 } from "./RG68_29"

export const RG68_22_28 = {
    "selectedValueColumn": "DistrictGroupCode",
    "selectedTitle": "Territory",
    "visuals": [
        {
            "title": "Sales Performance",
            "visual": [
                {
                    "columns": 12,
                    "rows": 2,
                    "visual": {
                        "id": 1,
                        "type": "advancedTable",
                        "colorTheme": 'colorTheme1',
                        "title": "Area Performance",
                        "binding": {
                            "data": {
                                "columns": [
                                    {
                                        "name": 'Area Name',
                                        "columnName": 'TerritoryName',
                                        "width": '200px',
                                        "align": "left",
                                        "sortable": true,
                                        "sum": false,
                                    },
                                    {
                                        "name": 'Actual Sales',
                                        "columnName": 'ActualSales',
                                        "width": '140px',
                                        "align": "right",
                                        "sortable": true,
                                        "sum": true,
                                    },
                                    {
                                        "name": 'LY Sales',
                                        "columnName": 'LYSales',
                                        "width": '125px',
                                        "align": "right",
                                        "sortable": true,
                                        "sum": true,
                                    },
                                    {
                                        "name": 'Growth %',
                                        "columnName": 'Growth',
                                        "width": '125px',
                                        "align": "right",
                                        "sortable": true,
                                        "sum": false,
                                        "percent": true
                                    },
                                    {
                                        "name": 'Target',
                                        "columnName": 'TargetSales',
                                        "width": '125px',
                                        "align": "right",
                                        "sortable": true,
                                        "sum": true,
                                    },
                                    {
                                        "name": 'Performance %',
                                        "columnName": 'Performance',
                                        "width": '150px',
                                        "align": "right",
                                        "sortable": true,
                                        "sum": false,
                                        "percent": true
                                    }
                                ],
                                "title": "TerritoryName",
                                "endpoint": "RG68.22",
                                "parameters": [
                                    { "key": "FromMonth", "value": "2024" },
                                    { "key": "FromYear", "value": "1" },
                                    { "key": "ToMonth", "value": "2024" },
                                    { "key": "ToYear", "value": "1" },
                                    { "key": "DistrictGroupCode", "value": "" },
                                    { "key": "ConfigTypeCode", "value": "" },
                                    { "key": "RegionCode", "value": "" }
                                ]
                            },
                            "context": {
                                "point": {
                                    "onClick": RG68_23
                                }
                            }
                        }
                    }
                }
            ]
        },
        {
            "title": "Monthly",
            "visual": [
                {
                    "columns": 12,
                    "rows": 2,
                    "visual": {
                        "id": 1,
                        "type": "advancedTable",
                        "colorTheme": 'colorTheme1',
                        "title": "Area Compararive Monthly",
                        "binding": {
                            "data": {
                                "columns": [
                                    {
                                        "name": 'Area Name',
                                        "columnName": 'TerritoryName',
                                        "width": '200px',
                                        "align": "left",
                                        "sortable": true,
                                        "sum": false,
                                    },
                                    {
                                        "name": 'Jan',
                                        "columnName": 'Jan',
                                        "width": '125px',
                                        "align": "right",
                                        "sortable": true,
                                        "sum": true
                                    },
                                    {
                                        "name": 'Feb',
                                        "columnName": 'Feb',
                                        "width": '125px',
                                        "align": "right",
                                        "sortable": true,
                                        "sum": true
                                    },
                                    {
                                        "name": 'Mar',
                                        "columnName": 'Mar',
                                        "width": '125px',
                                        "align": "right",
                                        "sortable": true,
                                        "sum": true
                                    },
                                    {
                                        "name": 'Apr',
                                        "columnName": 'Apr',
                                        "width": '125px',
                                        "align": "right",
                                        "sortable": true,
                                        "sum": true
                                    },
                                    {
                                        "name": 'May',
                                        "columnName": 'May',
                                        "width": '125px',
                                        "align": "right",
                                        "sortable": true,
                                        "sum": true
                                    },
                                    {
                                        "name": 'Jun',
                                        "columnName": 'Jun',
                                        "width": '125px',
                                        "align": "right",
                                        "sortable": true,
                                        "sum": true
                                    },
                                    {
                                        "name": 'Jul',
                                        "columnName": 'Jul',
                                        "width": '125px',
                                        "align": "right",
                                        "sortable": true,
                                        "sum": true
                                    },
                                    {
                                        "name": 'Aug',
                                        "columnName": 'Aug',
                                        "width": '125px',
                                        "align": "right",
                                        "sortable": true,
                                        "sum": true
                                    },
                                    {
                                        "name": 'Sep',
                                        "columnName": 'Sep',
                                        "width": '125px',
                                        "align": "right",
                                        "sortable": true,
                                        "sum": true
                                    },
                                    {
                                        "name": 'Oct',
                                        "columnName": 'Oct',
                                        "width": '125px',
                                        "align": "right",
                                        "sortable": true,
                                        "sum": true
                                    },
                                    {
                                        "name": 'Nov',
                                        "columnName": 'Nov',
                                        "width": '125px',
                                        "align": "right",
                                        "sortable": true,
                                        "sum": true
                                    },
                                    {
                                        "name": 'Dec',
                                        "columnName": 'Dec',
                                        "width": '125px',
                                        "align": "right",
                                        "sortable": true,
                                        "sum": true
                                    },
                                    {
                                        "name": 'Total Sales',
                                        "columnName": 'TotalSales',
                                        "width": '125px',
                                        "align": "right",
                                        "sortable": true,
                                        "sum": true
                                    }
                                ],
                                "title": "TerritoryName",
                                "endpoint": "RG68.28",
                                "parameters": [
                                    { "key": "FromMonth", "value": "2024" },
                                    { "key": "FromYear", "value": "1" },
                                    { "key": "ToMonth", "value": "2024" },
                                    { "key": "ToYear", "value": "1" },
                                    { "key": "DistrictGroupCode", "value": "" },
                                    { "key": "ConfigTypeCode", "value": "" },
                                    { "key": "RegionCode", "value": "" }
                                ]
                            },
                            "context": {
                                "point": {
                                    "onClick": RG68_29
                                }
                            }
                        }
                    }
                }
            ]
        }
    ]
}